import { TimeOffPolicy, TimeOffTemplate, TimeOffType } from '../timeoff';
import {
  ITimeOffPolicy,
  ITimeOffPolicyData,
  ITimeOffTemplate,
  ITimeOffTemplateData,
  ITimeOffType,
  ITimeOffTypeData
} from '../timeoff.types';

export const mockTimeOffTypesData = (): ITimeOffTypeData[] => [
  {
    id: 1,
    name: 'Vacation',
    code: null
  },
  {
    id: 2,
    name: 'Sick',
    code: 123
  }
];

export const mockTimeOffPoliciesData = (): ITimeOffPolicyData[] => [
  {
    id: 2,
    effective_date: '2023-01-01',
    expiry_date: '2023-12-31',
    yearly_entitlement: 5.0,
    is_accrual_supported: false,
    timeoff_display_option: 1,
    timeoff_unit: {
      value: 1,
      display_unit: 'Hours'
    },
    timeoff: {
      id: 2,
      name: 'Sick',
      code: null
    },
    is_entitlement_earned: false
  },
  {
    id: 3,
    effective_date: '2023-01-01',
    expiry_date: '2023-12-31',
    yearly_entitlement: 2.0,
    is_accrual_supported: false,
    timeoff_display_option: 0,
    timeoff_unit: {
      value: 0,
      display_unit: 'Days'
    },
    timeoff: {
      id: 3,
      name: 'Floater',
      code: null
    },
    is_entitlement_earned: false
  }
];

export const mockTimeOffTemplatesData = (): ITimeOffTemplateData[] => [
  {
    id: 1,
    name: 'Salary Employees',
    timeoffs: [
      {
        id: 1,
        name: 'Vacation',
        code: null
      },
      {
        id: 2,
        name: 'Sick',
        code: null
      }
    ]
  }
];

export const mockTimeOffTypes = (
  data: ITimeOffTypeData[] = mockTimeOffTypesData()
): ITimeOffType[] => data.map(item => new TimeOffType(item));

export const mockTimeOffPolicies = (
  data: ITimeOffPolicyData[] = mockTimeOffPoliciesData()
): ITimeOffPolicy[] => data.map(item => new TimeOffPolicy(item));

export const mockTimeOffTemplates = (
  data: ITimeOffTemplateData[] = mockTimeOffTemplatesData()
): ITimeOffTemplate[] => data.map(item => new TimeOffTemplate(item));
